import { Vue, Options } from 'vue-class-component';
import { PropType } from 'vue';
import {
  DeviceDTO,
  FunctionType,
} from '@/../client-generator/generated-clients/plants';

import DeviceSlotsListOverview from '@/views/components/DeviceAndSlotDetail/DeviceSlotsListOverview/DeviceSlotsListOverview.vue';

@Options({
  name: 'PlantDevicesItem',
  props: {
    device: {
      type: Object as PropType<DeviceDTO>,
      required: true,
    },
  },
  components: {
    DeviceSlotsListOverview,
  },
})
export default class PlantDevicesItem extends Vue {
  device!: DeviceDTO;

  get icon() {
    let icon = 'blueprint';

    switch (this.device.functionType) {
      case FunctionType.Thermo:
        icon = 'thermo';
        break;
      case FunctionType.Automation:
        icon = 'automation-2';
        break;
      case FunctionType.Energy:
        icon = 'energy';
        break;
      case FunctionType.Security:
        icon = 'security';
        break;
    }

    return icon;
  }
}
